import React from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
//import Alert from '@mui/material/Alert';
//import AlertTitle from '@mui/material/AlertTitle';

import logo from '../images/inform_logo.png';

const Login = (props) => {
  const attemptLogin = () => {
    window.authManager.login();
  }

  const splashStyle = {
    backgroundSize: 'cover, cover',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }

  return (
    <div className="login-container" style={splashStyle}>
      <Dialog
        modal={true}
        open={true}
        contentStyle={{width: '800px'}} >
        <div>
          <div style={{textAlign: 'center'}}>
          
          <img src={logo} width="177px" alt="InFORM Inspector" />

            <RaisedButton
              label="Login"
              style={{width: '177'}}
              primary={true}
              fullWidth={true}
              onClick={attemptLogin}
            />
           
            <p style={{textAlign: 'left', fontSize: '0.8em', fontWeight:"bold"}}>THIS IS A NOTICE OF MONITORING OF THE DEPARTMENT OF THE INTERIOR (DOI) INFORMATION SYSTEMS.</p>
            <p style={{textAlign: 'left', fontSize: '0.8em'}}>This computer system, including all related equipment, networks, and network devices (including Internet access), is provided by the Department of the Interior (DOI) in accordance with the agency policy for official use and 
            limited personal use. All agency computer systems may be monitored for all lawful purposes, including but not limited to, ensuring that use is authorized, for management of the system, to facilitate protection against unauthorized access, 
            and to verity security procedures, survivability and operational security. 
            </p>
            <p style={{textAlign: 'left', fontSize: '0.8em'}}>Any information on this computer systems may be examined, recorded, copied and used for authorized purposes at any time. All information, including personal information, 
            placed or sent over this system may be monitored, and users of this system are reminded that such monitoring does occur. Therefore, there should be no expectation of privacy with respect to use of this system. By logging into this agency 
            computer system, you acknowledge and consent to the monitoring of this system. Evidence of your use, authorized or unauthorized, collected during monitoring may be used for civil, criminal, administrative, or other adverse action. 
            Unauthorized or illegal use may subject you to prosecution.</p>

            <p style={{textAlign: 'left', fontSize: '0.8em'}}>These data are provided by the US Department of the Interior, Office of Wildland Fire “as is” and might contain errors or omissions. The User assumes the entire risk associated with its use of these data and bears all responsibility in determining whether these data are fit for the User’s intended use.</p><p style={{textAlign: 'left', fontSize: '0.8em'}}>The information contained in these data is dynamic and can be expected to change over time.
            The data are not better than the source systems that provide data through the Integrated Reporting of Wildland Fire Information (IRWIN) service.</p>

            <p style={{textAlign: 'left', fontSize: '0.8em'}}>By logging in, I agree to above terms of use.</p>
            
          </div>

        <div style={{textAlign: 'center', fontSize: '0.8em'}}>
            <p>{`Version: ${props.appConfig.appVersion + "." + props.appConfig.minorReleaseVersion}`}</p>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const mapStateToProps = state => ({
  appConfig: state.config
})

export default connect(mapStateToProps, null)(Login)
